module.exports = __webpack_public_path__ + "img/icon-jinxingzhong.b48ed7ed.png";